(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };
  const R = T.routes;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, ms = 300) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  const toast = (msg) => {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(() => { el.hidden = true; }, 2600);
  };

  const openDialog = (dlg) => {
    if (!dlg || dlg.open) return;
    dlg.showModal();
    document.body.classList.add('is-locked');
  };
  const closeDialog = (dlg) => {
    if (!dlg || !dlg.open) return;
    dlg.close();
  };
  document.addEventListener('close', (e) => {
    if (e.target.tagName === 'DIALOG' && !$$('dialog[open]').length) document.body.classList.remove('is-locked');
  }, true);

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDialog(document.getElementById(opener.dataset.openDrawer)); return; }
    const closer = e.target.closest('[data-close-dialog]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG' && e.target.open) {
      const r = e.target.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDialog(e.target);
    }
    const search = e.target.closest('[data-open-search]');
    if (search && $('#SearchModal')) {
      e.preventDefault();
      openDialog($('#SearchModal'));
      setTimeout(() => $('#SearchModal input[type=search]')?.focus(), 50);
    }
    const cartBtn = e.target.closest('[data-open-cart]');
    if (cartBtn && $('#CartDrawer')) { e.preventDefault(); openDialog($('#CartDrawer')); }
  });

  const header = $('[data-header]');
  const announcement = $('[data-announcement]');
  const setOffsets = () => {
    const ab = announcement ? announcement.offsetHeight : 0;
    document.documentElement.style.setProperty('--ab-height', ab + 'px');
    if (header) document.documentElement.style.setProperty('--header-offset', header.classList.contains('header--sticky') ? header.offsetHeight + 'px' : '0px');
  };
  setOffsets();
  window.addEventListener('resize', debounce(setOffsets, 150));
  if (header) {
    let last = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (header.classList.contains('header--transparent')) {
        const ab = announcement ? announcement.offsetHeight : 0;
        header.style.top = Math.max(ab - y, 0) + 'px';
      }
      if (header.classList.contains('header--sticky') && !header.matches(':focus-within')) {
        header.classList.toggle('is-hidden', y > last && y > 400 && !$$('details[open]', header).length);
      }
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    $$('[data-hover-details]', header).forEach((d) => {
      const li = d.parentElement;
      if (!window.matchMedia('(hover: hover)').matches) return;
      li.addEventListener('mouseenter', () => { d.open = true; });
      li.addEventListener('mouseleave', () => { d.open = false; });
    });
    document.addEventListener('click', (e) => {
      $$('[data-hover-details][open]', header).forEach((d) => { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') $$('[data-hover-details][open]', header).forEach((d) => { d.open = false; d.querySelector('summary').focus(); });
    });
  }

  if (announcement) {
    const items = $$('.announcement__item', announcement);
    if (items.length > 1) {
      let i = 0;
      setInterval(() => {
        if (announcement.matches(':hover')) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, (parseInt(announcement.dataset.speed, 10) || 5) * 1000);
    }
  }

  const initCountdowns = (root = document) => {
    $$('[data-countdown]', root).forEach((el) => {
      const target = new Date(el.dataset.countdown).getTime();
      if (isNaN(target)) return;
      const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
      const tick = () => {
        const d = target - Date.now();
        const v = d > 0 ? d : 0;
        const set = (k, n) => { const s = el.querySelector(`[data-cd="${k}"]`); if (s) s.textContent = pad(n); };
        set('d', Math.floor(v / 864e5));
        set('h', Math.floor((v / 36e5) % 24));
        set('m', Math.floor((v / 6e4) % 60));
        set('s', Math.floor((v / 1e3) % 60));
      };
      tick();
      setInterval(tick, 1000);
    });
  };
  initCountdowns();

  $$('[data-hero]').forEach((hero) => {
    const slides = $$('.hero__slide', hero);
    const dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    const speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
    hero.style.setProperty('--hero-speed', speed + 'ms');
    let i = 0;
    let timer;
    let paused = hero.dataset.autoplay !== 'true';
    const go = (n) => {
      slides[i].classList.remove('is-active');
      dots[i]?.classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      dots[i]?.classList.add('is-active');
      slides.forEach((s, k) => s.querySelectorAll('a,button').forEach((a) => { a.tabIndex = k === i ? 0 : -1; }));
      schedule();
    };
    const schedule = () => { clearTimeout(timer); if (!paused) timer = setTimeout(() => go(i + 1), speed); };
    dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.dataset.heroDot, 10))));
    const pauseBtn = $('[data-hero-pause]', hero);
    if (paused) hero.classList.add('is-paused');
    pauseBtn?.addEventListener('click', () => { paused = !paused; hero.classList.toggle('is-paused', paused); schedule(); });
    let sx = 0;
    hero.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); });
    go(0);
  });

  const countUp = (el) => {
    const end = parseFloat(el.dataset.countTo);
    if (isNaN(end)) return;
    const dur = 1600;
    const t0 = performance.now();
    const fmt = new Intl.NumberFormat();
    const step = (t) => {
      const p = Math.min((t - t0) / dur, 1);
      el.textContent = fmt.format(Math.round(end * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-revealed');
      $$('[data-count-to]', en.target).forEach(countUp);
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;
  const initReveal = (root = document) => {
    $$('[data-reveal]:not(.is-revealed)', root).forEach((el) => { if (io) io.observe(el); else el.classList.add('is-revealed'); });
  };
  initReveal();

  const initScrollers = (root = document) => {
    $$('[data-scroller]', root).forEach((sc) => {
      if (sc.dataset.bound) return;
      sc.dataset.bound = '1';
      const wrap = sc.parentElement;
      const by = () => (sc.firstElementChild ? sc.firstElementChild.getBoundingClientRect().width + 20 : sc.clientWidth * 0.8);
      wrap.querySelector('[data-scroll-prev]')?.addEventListener('click', () => sc.scrollBy({ left: -by(), behavior: 'smooth' }));
      wrap.querySelector('[data-scroll-next]')?.addEventListener('click', () => sc.scrollBy({ left: by(), behavior: 'smooth' }));
    });
  };
  initScrollers();

  const Cart = {
    sectionIds() {
      const ids = ['cart-drawer'];
      const page = $('[data-cart-page-content] [data-cart]');
      if (page) ids.push(page.dataset.sectionId);
      return ids;
    },
    render(sections, count) {
      if (!sections) return;
      const drawerHtml = sections['cart-drawer'];
      if (drawerHtml) {
        const doc = parse(drawerHtml);
        const fresh = $('[data-cart-drawer-content]', doc);
        const cur = $('[data-cart-drawer-content]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        const sup = $('[data-cart-count-inline]', doc);
        if (sup && $('[data-cart-count-inline]')) $('[data-cart-count-inline]').textContent = sup.textContent;
      }
      const page = $('[data-cart-page-content] [data-cart]');
      if (page && sections[page.dataset.sectionId]) {
        const doc = parse(sections[page.dataset.sectionId]);
        const fresh = $('[data-cart-page-content]', doc);
        if (fresh) $('[data-cart-page-content]').innerHTML = fresh.innerHTML;
      }
      if (typeof count === 'number') {
        $$('[data-cart-count]').forEach((b) => { b.textContent = count; b.hidden = count === 0; });
      }
      initWishlistButtons();
    },
    async add(items, btn) {
      btn?.classList.add('is-loading');
      try {
        const res = await fetch(R.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: this.sectionIds(), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
        const cart = await (await fetch(R.cart + '.js')).json();
        this.render(data.sections, cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        if ($('#CartDrawer')) openDialog($('#CartDrawer'));
        else window.location.href = R.cart;
        return true;
      } catch (err) {
        toast(err.message || T.strings.cartError);
        return false;
      } finally {
        btn?.classList.remove('is-loading');
      }
    },
    async change(line, quantity) {
      const item = $$(`.cart-item[data-line="${line}"]`);
      item.forEach((i) => i.classList.add('is-updating'));
      try {
        const res = await fetch(R.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: this.sectionIds(), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message);
        this.render(data.sections, data.item_count);
      } catch (err) {
        toast(err.message || T.strings.cartError);
        item.forEach((i) => i.classList.remove('is-updating'));
      }
    },
    note: debounce((value) => {
      fetch(R.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: value }) });
    }, 500)
  };
  window.ThemeCart = Cart;

  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault();
      Cart.add([{ id: parseInt(q.dataset.quickAdd, 10), quantity: 1 }], q);
      return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { Cart.change(parseInt(rm.dataset.lineRemove, 10), 0); return; }
    const qb = e.target.closest('[data-qty-change]');
    if (qb) {
      const wrap = qb.closest('[data-qty]');
      const input = $('input', wrap);
      const min = parseInt(input.min || '0', 10);
      const max = input.max ? parseInt(input.max, 10) : Infinity;
      const v = Math.min(Math.max((parseInt(input.value, 10) || 0) + parseInt(qb.dataset.qtyChange, 10), min), max);
      input.value = v;
      if (input.dataset.lineQty) Cart.change(parseInt(input.dataset.lineQty, 10), v);
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-line-qty]')) Cart.change(parseInt(e.target.dataset.lineQty, 10), parseInt(e.target.value, 10) || 0);
    if (e.target.matches('[data-cart-note]')) Cart.note(e.target.value);
  });
  document.addEventListener('input', (e) => { if (e.target.matches('[data-cart-note]')) Cart.note(e.target.value); });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form || !$('#CartDrawer')) return;
    e.preventDefault();
    const fd = new FormData(form);
    const btn = $('[data-atc]', form);
    const err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    const props = {};
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
    const item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    if (Object.keys(props).length) item.properties = props;
    if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
    Cart.add([item], btn);
  });

  const initProduct = (root) => {
    const sectionId = root.dataset.sectionId;
    const picker = $('[data-variant-picker]', root);
    const variants = picker ? JSON.parse($('[data-variants-json]', picker).textContent) : [];
    const track = $('[data-gallery-track]', root);
    const form = $('form[data-type="add-to-cart-form"]', root);
    const lightbox = document.getElementById('Lightbox-' + sectionId);

    const scrollToMedia = (id) => {
      const item = id && track ? $(`[data-media-id="${id}"]`, track) : null;
      if (!item) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        if (item.dataset.index !== '0') item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
    };

    if (track) {
      const cur = $('[data-gallery-current]', root);
      const dots = $$('.product__dots span', root);
      track.addEventListener('scroll', debounce(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        if (cur) cur.textContent = idx + 1;
        dots.forEach((d, k) => d.classList.toggle('is-active', k === idx));
      }, 60), { passive: true });
    }

    if (track && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const setOrigin = (z, e) => {
        const r = z.getBoundingClientRect();
        const img = z.querySelector('img');
        if (img) img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
      };
      $$('[data-zoom]', track).forEach((z) => {
        z.addEventListener('mouseenter', (e) => { setOrigin(z, e); z.classList.add('is-zooming'); });
        z.addEventListener('mousemove', (e) => setOrigin(z, e));
        z.addEventListener('mouseleave', () => z.classList.remove('is-zooming'));
      });
    }

    if (lightbox) {
      root.addEventListener('click', (e) => {
        const z = e.target.closest('[data-zoom]');
        if (!z) return;
        openDialog(lightbox);
        const slides = $$('.lightbox__slide', lightbox);
        const imgIndex = $$('[data-zoom]', root).indexOf(z);
        const t = $('[data-lightbox-track]', lightbox);
        requestAnimationFrame(() => { t.scrollLeft = (slides[imgIndex]?.offsetLeft) || 0; });
      });
    }

    if (picker) {
      picker.addEventListener('change', async () => {
        const selected = $$('fieldset', picker).map((fs) => $('input:checked', fs)?.value);
        $$('[data-option-value]', picker).forEach((s, k) => { s.textContent = selected[k] || ''; });
        const v = variants.find((x) => x.options.every((o, k) => o === selected[k]));
        const atc = $('[data-atc]', root);
        const label = $('[data-atc-label]', root);
        const sticky = $('[data-sticky-btn]');
        if (!v) {
          if (atc) atc.disabled = true;
          if (label) label.textContent = T.strings.unavailable;
          if (sticky) { sticky.disabled = true; sticky.textContent = T.strings.unavailable; }
          return;
        }
        const idInput = form ? $('[data-variant-id]', form) : null;
        if (idInput) idInput.value = v.id;
        $$('form input[name="id"]', root).forEach((inp) => { inp.value = v.id; });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (atc) atc.disabled = !v.available;
        if (label) label.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
        if (sticky) { sticky.disabled = !v.available; sticky.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
        const dyn = $('[data-dynamic-checkout]', root);
        if (dyn) dyn.hidden = !v.available;
        if (v.featured_media) scrollToMedia(v.featured_media.id);
        try {
          const res = await fetch(`${root.dataset.url}?variant=${v.id}&section_id=${sectionId}`);
          const doc = parse(await res.text());
          ['[data-product-price]', '.variants__values', '.buy__pickup'].forEach((sel) => {
            const fresh = $$(sel, doc);
            $$(sel, root).forEach((el, k) => { if (fresh[k]) el.innerHTML = fresh[k].innerHTML; });
          });
          const sp = $('[data-sticky-price]', doc);
          if (sp && $('[data-sticky-price]')) $('[data-sticky-price]').innerHTML = sp.innerHTML;
          $$('fieldset', picker).forEach((fs, k) => { const inp = $$('input', fs).find((i) => i.value === selected[k]); if (inp) inp.checked = true; });
        } catch (e) {}
      });
    }

    const stickyBar = $('[data-sticky-atc]');
    const buy = $('.buy', root);
    if (stickyBar && buy && 'IntersectionObserver' in window) {
      stickyBar.hidden = false;
      new IntersectionObserver(([en]) => {
        stickyBar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(buy);
    }

    const current = $('[data-recently-viewed-current]');
    if (current) {
      const handle = JSON.parse(current.textContent);
      const list = store.get('rv', []).filter((h) => h !== handle);
      list.unshift(handle);
      store.set('rv', list.slice(0, 12));
    }
  };
  $$('[data-product]').forEach(initProduct);

  const loadCards = async (handles, grid, wrapTag) => {
    const results = await Promise.all(handles.map(async (h) => {
      try {
        const res = await fetch(`${R.root.replace(/\/$/, '')}/products/${h}?section_id=card-fragment`);
        if (!res.ok) return null;
        const doc = parse(await res.text());
        const item = $('.product-grid__item', doc);
        return item && item.innerHTML.trim() ? item : null;
      } catch (e) { return null; }
    }));
    results.filter(Boolean).forEach((item) => {
      const el = document.createElement(wrapTag);
      el.className = 'product-grid__item';
      el.innerHTML = item.innerHTML;
      grid.appendChild(el);
    });
    initWishlistButtons(grid);
    return results.filter(Boolean).length;
  };

  $$('[data-recently-viewed]').forEach(async (sec) => {
    const current = $('[data-recently-viewed-current]');
    const curHandle = current ? JSON.parse(current.textContent) : null;
    const limit = parseInt(sec.dataset.limit, 10) || 6;
    const handles = store.get('rv', []).filter((h) => h !== curHandle).slice(0, limit);
    if (!handles.length) return;
    const n = await loadCards(handles, $('[data-recently-grid]', sec), 'div');
    if (n) { sec.hidden = false; initReveal(sec); }
  });

  const recs = $('[data-recommendations]');
  if (recs && recs.dataset.url && !recs.querySelector('.product-grid')) {
    fetch(recs.dataset.url).then((r) => r.text()).then((html) => {
      const doc = parse(html);
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) {
        recs.innerHTML = fresh.innerHTML;
        initScrollers(recs);
        initReveal(recs);
        initWishlistButtons(recs);
      }
    }).catch(() => {});
  }

  const wish = {
    all: () => store.get('wishlist', []),
    has: (h) => wish.all().includes(h),
    toggle(h) {
      const list = wish.all();
      const i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.unshift(h);
      store.set('wishlist', list);
      return i === -1;
    }
  };
  const updateWishCount = () => {
    const n = wish.all().length;
    $$('[data-wishlist-count]').forEach((b) => { b.textContent = n; b.hidden = n === 0; });
  };
  function initWishlistButtons(root = document) {
    $$('[data-wishlist-toggle]', root).forEach((b) => {
      const on = wish.has(b.dataset.wishlistToggle);
      b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', on ? T.strings.wishlistRemove : T.strings.wishlistAdd);
    });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    const h = b.dataset.wishlistToggle;
    const on = wish.toggle(h);
    $$(`[data-wishlist-toggle="${h}"]`).forEach((x) => {
      x.setAttribute('aria-pressed', on);
      x.setAttribute('aria-label', on ? T.strings.wishlistRemove : T.strings.wishlistAdd);
    });
    toast(on ? '♥ ' + T.strings.wishlistAdd.replace(/^Add to/, 'Saved to') : T.strings.wishlistRemove);
    updateWishCount();
    const page = $('[data-wishlist-page]');
    if (page && !on) { b.closest('.product-grid__item')?.remove(); if (!wish.all().length) $('[data-wishlist-empty]', page).hidden = false; }
  });
  initWishlistButtons();
  updateWishCount();
  const wishPage = $('[data-wishlist-page]');
  if (wishPage) {
    const handles = wish.all();
    if (!handles.length) $('[data-wishlist-empty]', wishPage).hidden = false;
    else loadCards(handles.slice(0, 40), $('[data-wishlist-grid]', wishPage), 'li').then((n) => { if (!n) $('[data-wishlist-empty]', wishPage).hidden = false; });
  }

  const sInput = $('[data-predictive-search]');
  if (sInput && R.predictiveSearch) {
    const out = $('[data-predictive-results]');
    const popular = $('[data-search-popular]');
    let ctrl;
    sInput.addEventListener('input', debounce(async () => {
      const q = sInput.value.trim();
      if (popular) popular.hidden = q.length > 0;
      if (!q) { out.innerHTML = ''; return; }
      ctrl?.abort();
      ctrl = new AbortController();
      try {
        const res = await fetch(`${R.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`, { signal: ctrl.signal });
        const doc = parse(await res.text());
        const p = $('.predictive', doc);
        out.innerHTML = p ? p.outerHTML : '';
      } catch (e) {}
    }, 250));
  }

  const Facets = {
    root: () => $('[data-collection]'),
    async load(url, push = true, append = false) {
      const sec = this.root();
      if (!sec) { window.location.href = url; return; }
      sec.classList.add('is-loading');
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sec.dataset.sectionId);
      try {
        const doc = parse(await (await fetch(u.toString())).text());
        const fresh = $('[data-results]', doc);
        const freshFacets = $('[data-facets-root]', doc);
        if (append) {
          const grid = $('[data-product-grid]', sec);
          $$('[data-product-grid] > *', fresh).forEach((li) => grid.appendChild(li));
          const lm = $('.load-more', sec);
          const flm = $('.load-more', fresh);
          if (lm) { if (flm) lm.replaceWith(flm); else lm.remove(); }
        } else {
          const wasOpen = $('[data-facets]', sec)?.classList.contains('is-open');
          const openGroups = $$('[data-facets] details', sec).map((d) => d.open);
          if (fresh) $('[data-results]', sec).innerHTML = fresh.innerHTML;
          if (freshFacets) {
            $('[data-facets-root]', sec).innerHTML = freshFacets.innerHTML;
            $$('[data-facets] details', sec).forEach((d, k) => { if (openGroups[k] !== undefined) d.open = openGroups[k]; });
            if (wasOpen) $('[data-facets]', sec).classList.add('is-open');
          }
        }
        applyGrid();
        initReveal(sec);
        initWishlistButtons(sec);
        if (push) { u.searchParams.delete('section_id'); window.history.pushState({ facets: true }, '', u.toString()); }
      } catch (e) {
        window.location.href = url;
      } finally {
        sec.classList.remove('is-loading');
      }
    }
  };
  const facetSubmit = debounce(() => {
    const form = $('[data-facets-form]');
    if (!form) return;
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
    Facets.load(`${window.location.pathname}?${params.toString()}`);
  }, 450);
  document.addEventListener('change', (e) => { if (e.target.closest('[data-facets-form]')) facetSubmit(); });
  document.addEventListener('input', (e) => { if (e.target.closest('.price-range')) facetSubmit(); });
  document.addEventListener('submit', (e) => { if (e.target.matches('[data-facets-form]')) { e.preventDefault(); facetSubmit(); } });
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-facet-link], [data-facets-clear], .collection .pagination a');
    if (link && Facets.root()) { e.preventDefault(); Facets.load(link.href); if (link.closest('.pagination')) Facets.root().scrollIntoView({ behavior: 'smooth' }); return; }
    const more = e.target.closest('[data-load-more]');
    if (more) { e.preventDefault(); more.classList.add('is-loading'); Facets.load(more.href, false, true); return; }
    if (e.target.closest('[data-facets-open]')) { $('[data-facets]')?.classList.add('is-open'); document.body.classList.add('is-locked'); return; }
    if (e.target.closest('[data-facets-close]')) { $('[data-facets]')?.classList.remove('is-open'); document.body.classList.remove('is-locked'); return; }
    const g = e.target.closest('[data-grid-cols]');
    if (g) { store.set('grid', g.dataset.gridCols); applyGrid(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && $('[data-facets].is-open')) { $('[data-facets]').classList.remove('is-open'); document.body.classList.remove('is-locked'); }
  });
  window.addEventListener('popstate', (e) => { if (e.state && e.state.facets) Facets.load(window.location.href, false); });
  function applyGrid() {
    const cols = store.get('grid', null);
    if (!cols || !window.matchMedia('(min-width: 750px)').matches) return;
    $$('[data-product-grid]').forEach((g) => { g.dataset.grid = cols; });
    $$('[data-grid-cols]').forEach((b) => b.classList.toggle('is-active', b.dataset.gridCols === cols));
  }
  applyGrid();

  $$('.look').forEach((look) => {
    const set = (i) => {
      $$('[data-look-target]', look).forEach((h) => h.classList.toggle('is-active', h.dataset.lookTarget === i));
      $$('[data-look-item]', look).forEach((h) => h.classList.toggle('is-active', h.dataset.lookItem === i));
    };
    look.addEventListener('mouseover', (e) => { const t = e.target.closest('[data-look-target],[data-look-item]'); if (t) set(t.dataset.lookTarget || t.dataset.lookItem); });
    look.addEventListener('click', (e) => {
      const t = e.target.closest('[data-look-target]');
      if (!t) return;
      set(t.dataset.lookTarget);
      $(`[data-look-item="${t.dataset.lookTarget}"]`, look)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  document.addEventListener('click', async (e) => {
    const s = e.target.closest('[data-share]');
    if (!s) return;
    const data = { title: s.dataset.shareTitle, url: s.dataset.shareUrl };
    if (navigator.share) { try { await navigator.share(data); } catch (err) {} return; }
    try { await navigator.clipboard.writeText(data.url); toast(T.strings.copied); } catch (err) {}
  });

  $$('[data-auth]').forEach((auth) => {
    const show = (v) => $$('[data-auth-view]', auth).forEach((el) => { el.hidden = el.dataset.authView !== v; });
    if (window.location.hash === '#recover' || auth.querySelector('[data-auth-view="recover"] .form-success, [data-auth-view="recover"] .form-error')) show('recover');
    auth.addEventListener('click', (e) => { const b = e.target.closest('[data-auth-switch]'); if (b) show(b.dataset.authSwitch); });
  });

  $$('select[data-default]').forEach((sel) => { if (sel.dataset.default) sel.value = sel.dataset.default; });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-confirm-delete]');
    if (f && !window.confirm(f.dataset.confirmDelete)) e.preventDefault();
  });

  document.addEventListener('shopify:section:load', (e) => {
    initReveal(e.target);
    initScrollers(e.target);
    initCountdowns(e.target);
    initWishlistButtons(e.target);
    $$('[data-product]', e.target).forEach(initProduct);
    $$('[data-reveal]', e.target).forEach((el) => el.classList.add('is-revealed'));
    setOffsets();
  });
  if (window.Shopify && window.Shopify.designMode) {
    $$('[data-reveal]').forEach((el) => el.classList.add('is-revealed'));
  }
})();
